export function IpGuideLinux() {
  return (
    <div className="space-y-6">
      {/* Step 1 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          1
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Terminal öffnen:{" "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">Ctrl</kbd>
            {" + "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">Alt</kbd>
            {" + "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">T</kbd>
            {" "}(Ubuntu) oder Terminal-App suchen.
          </p>
          <svg viewBox="0 0 300 100" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            {/* Ubuntu-style desktop */}
            <defs>
              <linearGradient id="ubuntuDesk" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2c001e" />
                <stop offset="100%" stopColor="#44134a" />
              </linearGradient>
            </defs>
            <rect width="300" height="100" fill="url(#ubuntuDesk)" />
            {/* GNOME top bar */}
            <rect width="300" height="22" fill="rgba(0,0,0,0.5)" />
            <text x="16" y="15" fontSize="11" fontWeight="500" fill="#e0e0e0">Aktivitäten</text>
            <text x="150" y="15" textAnchor="middle" fontSize="11" fill="#e0e0e0">9:41</text>
            {/* Right icons */}
            <text x="268" y="15" fontSize="11" fill="#e0e0e0">◈</text>
            <text x="282" y="15" fontSize="11" fill="#e0e0e0">⏻</text>
            {/* Terminal window */}
            <rect x="50" y="26" width="200" height="68" rx="6" fill="#1e1e1e" stroke="#555" strokeWidth="0.8" />
            {/* GNOME terminal title bar – circles LEFT (correct!) */}
            <rect x="50" y="26" width="200" height="20" rx="6" fill="#3a3a3a" />
            <rect x="50" y="36" width="200" height="10" fill="#3a3a3a" />
            <circle cx="63" cy="36" r="5" fill="#ff5f57" />
            <circle cx="76" cy="36" r="5" fill="#febc2e" />
            <circle cx="89" cy="36" r="5" fill="#28c840" />
            <text x="150" y="40" textAnchor="middle" fontSize="8.5" fill="#9aa0a6">Terminal</text>
            {/* Content */}
            <text x="60" y="57" fontSize="9" fill="#50fa7b" fontFamily="Courier New, monospace">user@pc:~$</text>
            <rect x="120" y="49" width="7" height="12" fill="#f8f8f2" opacity="0.7" />
            {/* Keyboard shortcut badge */}
            <rect x="4" y="4" width="88" height="13" rx="3" fill="rgba(0,0,0,0.55)" />
            <text x="48" y="14" textAnchor="middle" fontSize="8" fill="#fff">Ctrl + Alt + T</text>
          </svg>
        </div>
      </div>

      {/* Step 2 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          2
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Befehl{" "}
            <code className="bg-gray-100 border border-gray-200 rounded px-1.5 py-0.5 text-xs font-mono text-gray-800">hostname -I</code>{" "}
            eingeben und{" "}
            <kbd className="bg-gray-100 border border-gray-300 rounded px-1.5 py-0.5 text-xs font-mono">Enter</kbd> drücken.
          </p>
          <svg viewBox="0 0 300 130" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            <rect width="300" height="130" rx="6" fill="#1e1e1e" />
            {/* GNOME Terminal title bar – circles LEFT */}
            <rect width="300" height="28" rx="6" fill="#3a3a3a" />
            <rect x="0" y="14" width="300" height="14" fill="#3a3a3a" />
            <circle cx="14" cy="14" r="6" fill="#ff5f57" />
            <circle cx="28" cy="14" r="6" fill="#febc2e" />
            <circle cx="42" cy="14" r="6" fill="#28c840" />
            <text x="150" y="18" textAnchor="middle" fontSize="9" fill="#9aa0a6">Terminal</text>
            {/* Command */}
            <text x="12" y="48" fontSize="9.5" fill="#50fa7b" fontFamily="Courier New, monospace">user@pc:~$</text>
            <text x="74" y="48" fontSize="9.5" fill="#f8f8f2" fontFamily="Courier New, monospace">hostname -I</text>
            <rect x="146" y="38" width="8" height="13" fill="#f8f8f2" opacity="0.75" />
            {/* Hint bar */}
            <rect x="0" y="108" width="300" height="22" fill="rgba(80,250,123,0.1)" />
            <text x="150" y="122" textAnchor="middle" fontSize="8.5" fill="#50fa7b">hostname -I eingeben → Enter drücken</text>
          </svg>
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          3
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Die <strong>erste Adresse</strong> (z.&thinsp;B.{" "}
            <code className="bg-gray-100 border border-gray-200 rounded px-1.5 py-0.5 text-xs font-mono text-gray-800">192.168.x.x</code>) ist deine IP.
          </p>
          <svg viewBox="0 0 300 135" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-sm mx-auto block rounded-lg" aria-hidden="true">
            <rect width="300" height="135" rx="6" fill="#1e1e1e" />
            {/* GNOME Terminal title bar */}
            <rect width="300" height="28" rx="6" fill="#3a3a3a" />
            <rect x="0" y="14" width="300" height="14" fill="#3a3a3a" />
            <circle cx="14" cy="14" r="6" fill="#ff5f57" />
            <circle cx="28" cy="14" r="6" fill="#febc2e" />
            <circle cx="42" cy="14" r="6" fill="#28c840" />
            <text x="150" y="18" textAnchor="middle" fontSize="9" fill="#9aa0a6">Terminal</text>
            {/* Command echo */}
            <text x="12" y="48" fontSize="9.5" fill="#50fa7b" fontFamily="Courier New, monospace">user@pc:~$</text>
            <text x="74" y="48" fontSize="9.5" fill="#f8f8f2" fontFamily="Courier New, monospace">hostname -I</text>
            {/* Output – highlighted */}
            <rect x="8" y="54" width="210" height="18" rx="3" fill="rgba(239,68,68,0.18)" />
            <rect x="8" y="54" width="210" height="18" rx="3" fill="none" stroke="#ef4444" strokeWidth="1.6" />
            <text x="12" y="67" fontSize="11" fill="#fbbf24" fontFamily="Courier New, monospace" fontWeight="bold">192.168.1.42</text>
            <text x="102" y="67" fontSize="10" fill="#555" fontFamily="Courier New, monospace">  fe80::1a2b:3c4d</text>
            <polygon points="220,63 228,58 228,68" fill="#ef4444" />
            {/* Next prompt */}
            <text x="12" y="90" fontSize="9.5" fill="#50fa7b" fontFamily="Courier New, monospace">user@pc:~$</text>
            {/* Label */}
            <rect x="8" y="104" width="148" height="14" rx="3" fill="rgba(239,68,68,0.18)" />
            <text x="82" y="114" textAnchor="middle" fontSize="8.5" fill="#fca5a5">← Das ist deine IP-Adresse</text>
          </svg>
        </div>
      </div>
    </div>
  );
}
